import script from "./ModalAiSetup.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalAiSetup.vue?vue&type=script&setup=true&lang=ts"

import "./ModalAiSetup.vue?vue&type=style&index=0&id=428c4a20&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-428c4a20"]])

export default __exports__